<template>
  <div>
    <div v-if="isShowTooltip" class="exceeds" @mouseenter="changeVsisible(refName)">
      <span :ref="refName">{{ content }}</span>
    </div>
    <a-tooltip
      v-else
      :title="content"
      placement="top">
      <div class="exceeds">
        <span>{{ content }}</span>
      </div>
    </a-tooltip>
  </div>
</template>
<script>
export default {
  name: 'TextTooltip',
  props: {
    content: {
      type: String,
      default: null
    },
    refName: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isShowTooltip: true
    }
  },
  methods: {
    changeVsisible (refName) {
      const pWidth = this.$refs[refName].parentNode.offsetWidth
      const contentWidth = this.$refs[refName].offsetWidth
      if (pWidth < contentWidth) {
        this.isShowTooltip = false
      }
    }
  }
}
</script>
<style lang='less' scoped>
.exceeds {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
